import React, { useState } from 'react';
import OfferPDFPreview from '../components/calculator/OfferPDFPreview';
import { Button } from '../components/ui/button';
import { ArrowLeft, Download, Printer, Home, Building } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const PDFPreviewPage = () => {
  const navigate = useNavigate();
  const [propertyType, setPropertyType] = useState('apartament');

  // Mock data for preview - in production this will come from calculator
  const mockIntermediaryData = {
    companyName: "FINANȚARE PRIN CREDIT SRL",
    cui: "RO31284352",
    jNumber: "J40/1234/2020",
    address: "București, Calea Moșilor 308, Sector 2",
    phone: "0729 414 546",
    email: "office@finantarepricredit.ro",
    website: "www.finantarepricredit.ro",
    logoUrl: null
  };

  const mockClientData = {
    fullName: "POPESCU ION-ALEXANDRU",
    cnp: "1850315123456"
  };

  const mockCreditParams = {
    propertyValueEuro: 120000,
    propertyValueRon: 600000,
    creditValueRon: 480000,
    downPaymentRon: 120000,
    periodYears: 30,
    periodMonths: 360,
    maxDebtRatio: "40%/45%",
    creditType: "Credit Ipotecar",
    propertyType: propertyType
  };

  // Ofertele trebuie să vină exact din calculator cu toate detaliile
  // IMPORTANT: evaluationFeeApartment și evaluationFeeHouse sunt diferite!
  const mockBankOffers = [
    {
      bankName: "BRD",
      productName: "Credit Ipotecar cu virare venit și clasă energetică A/B",
      creditType: "Credit Ipotecar",
      fixedRate: "Fixă 3 ani - 4.99%",
      variableRate: "IRCC + 2.29%",
      ircc: "5.55%",
      monthlyPaymentFixed: "2,150 RON",
      monthlyPaymentVariable: "2,450 RON",
      dae: "5.85%",
      analysisCommission: "0 RON",
      adminCommission: "0 RON",
      archiveFee: "0 RON",
      evaluationFeeApartment: "800 RON",
      evaluationFeeHouse: "1,200 RON",
      lifeInsurance: "inclus în rată",
      padInsurance: "obligatorie",
      optionalPropertyInsurance: "opțional - 150 RON/an",
      earlyRepaymentCommission: "0%",
      preApprovalValidity: "90 de zile",
      totalCost: "774,000 RON"
    },
    {
      bankName: "Banca Transilvania",
      productName: "Credit Ipotecar cu virare salariu",
      creditType: "Credit Ipotecar",
      fixedRate: "Fixă 3 ani - 5.15%",
      variableRate: "IRCC + 2.39%",
      ircc: "5.55%",
      monthlyPaymentFixed: "2,083 RON",
      monthlyPaymentVariable: "2,380 RON",
      dae: "6.10%",
      analysisCommission: "0 RON",
      adminCommission: "0 RON",
      archiveFee: "0 RON",
      evaluationFeeApartment: "600 RON",
      evaluationFeeHouse: "900 RON",
      lifeInsurance: "opțional",
      padInsurance: "obligatorie",
      optionalPropertyInsurance: "opțional - 180 RON/an",
      earlyRepaymentCommission: "0%",
      preApprovalValidity: "30 de zile",
      totalCost: "749,880 RON"
    },
    {
      bankName: "BCR",
      productName: "Credit Ipotecar Verde cu asigurări de viață",
      creditType: "Credit Ipotecar",
      fixedRate: "Fixă 3 ani - 4.79%",
      variableRate: "IRCC + 2.3%",
      ircc: "5.55%",
      monthlyPaymentFixed: "2,200 RON",
      monthlyPaymentVariable: "2,500 RON",
      dae: "5.65%",
      analysisCommission: "0 RON",
      adminCommission: "25 RON/lună",
      archiveFee: "0 RON",
      evaluationFeeApartment: "750 RON",
      evaluationFeeHouse: "1,100 RON",
      lifeInsurance: "inclus",
      padInsurance: "obligatorie",
      optionalPropertyInsurance: "inclus în pachet",
      earlyRepaymentCommission: "0%",
      preApprovalValidity: "90 de zile",
      totalCost: "792,000 RON"
    },
    {
      bankName: "UniCredit",
      productName: "Credit Ipotecar Verde cu virare/rulaj 70%",
      creditType: "Credit Ipotecar",
      fixedRate: "Fixă 5 ani - 5.29%",
      variableRate: "IRCC + 2.1%",
      ircc: "5.55%",
      monthlyPaymentFixed: "2,050 RON",
      monthlyPaymentVariable: "2,320 RON",
      dae: "5.95%",
      analysisCommission: "0 RON",
      adminCommission: "0 RON",
      archiveFee: "50 RON",
      evaluationFeeApartment: "700 RON",
      evaluationFeeHouse: "1,000 RON",
      lifeInsurance: "opțional",
      padInsurance: "obligatorie",
      optionalPropertyInsurance: "opțional - 200 RON/an",
      earlyRepaymentCommission: "0%",
      preApprovalValidity: "60 de zile",
      totalCost: "738,000 RON"
    },
    {
      bankName: "ING",
      productName: "Credit Ipotecar cu virare salariu",
      creditType: "Credit Ipotecar",
      fixedRate: "Fixă 3 ani - 5.45%",
      variableRate: "IRCC + 2.5%",
      ircc: "5.55%",
      monthlyPaymentFixed: "2,180 RON",
      monthlyPaymentVariable: "2,490 RON",
      dae: "6.25%",
      analysisCommission: "0 RON",
      adminCommission: "0 RON",
      archiveFee: "0 RON",
      evaluationFeeApartment: "650 RON",
      evaluationFeeHouse: "950 RON",
      lifeInsurance: "opțional",
      padInsurance: "obligatorie",
      optionalPropertyInsurance: "opțional - 170 RON/an",
      earlyRepaymentCommission: "0%",
      preApprovalValidity: "90 de zile",
      totalCost: "784,800 RON"
    }
  ];

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Control Bar - Hidden on print */}
      <div className="bg-white shadow-md p-4 flex items-center justify-between print:hidden sticky top-0 z-10">
        <Button variant="outline" onClick={() => navigate(-1)}>
          <ArrowLeft className="w-4 h-4 mr-2" />
          Înapoi
        </Button>
        <div className="flex items-center gap-4">
          <h1 className="text-lg font-semibold text-gray-800">
            Preview PDF Ofertă - Simulare Soluții de Creditare
          </h1>
          {/* Property Type Toggle for Demo */}
          <div className="flex gap-2 bg-gray-100 p-1 rounded-lg">
            <Button 
              size="sm"
              variant={propertyType === 'apartament' ? 'default' : 'ghost'}
              onClick={() => setPropertyType('apartament')}
            >
              <Building className="w-4 h-4 mr-1" />
              Apartament
            </Button>
            <Button 
              size="sm"
              variant={propertyType === 'casa' ? 'default' : 'ghost'}
              onClick={() => setPropertyType('casa')}
            >
              <Home className="w-4 h-4 mr-1" />
              Casă
            </Button>
          </div>
        </div>
        <div className="flex gap-2">
          <Button variant="outline" onClick={handlePrint}>
            <Printer className="w-4 h-4 mr-2" />
            Printează
          </Button>
          <Button className="bg-blue-600 hover:bg-blue-700">
            <Download className="w-4 h-4 mr-2" />
            Descarcă PDF
          </Button>
        </div>
      </div>

      {/* Info Banner */}
      <div className="bg-yellow-50 border-b border-yellow-200 p-3 text-center text-sm text-yellow-800 print:hidden">
        <strong>Demo:</strong> Schimbă între Apartament și Casă pentru a vedea cum se modifică Taxa de Evaluare în tabel.
      </div>

      {/* PDF Preview Container */}
      <div className="p-8 print:p-0">
        <div className="bg-white shadow-xl rounded-lg overflow-hidden print:shadow-none print:rounded-none">
          <OfferPDFPreview 
            intermediaryData={mockIntermediaryData}
            clientData={mockClientData}
            creditParams={{...mockCreditParams, propertyType}}
            bankOffers={mockBankOffers}
          />
        </div>
      </div>

      {/* Print Styles */}
      <style>{`
        @media print {
          @page {
            size: A4 landscape;
            margin: 10mm;
          }
          body {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }
        }
      `}</style>
    </div>
  );
};

export default PDFPreviewPage;
